import { render } from "./AdvisorNewLink.vue?vue&type=template&id=f5c7b2b0&scoped=true"
import script from "./AdvisorNewLink.vue?vue&type=script&lang=ts"
export * from "./AdvisorNewLink.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-f5c7b2b0"

export default script